<script lang="ts">
import { defineComponent, PropType } from 'vue'
import ReplyIcon from 'vue-material-design-icons/Reply.vue'
import TextTruncationMultiLine from '@/components/formatter/TextTruncationMultiLine.vue'

export default defineComponent({
  name: 'TimelineComment',

  components: {
    ReplyIcon,
    TextTruncationMultiLine,
  },

  props: {
    /**
     * コメント URL
     * @description 無指定の場合はアンカー設定されない
     */
    href: {
      type: String,
      default: undefined,
    },

    /**
     * 返信コメントかどうか
     */
    isReply: {
      type: Boolean,
      default: false,
    },

    /**
     * 表示最大行数
     * @description 0 の場合は無制限
     * @description href とあわせて 1 以上が指定された場合のみ、「続きを読む」が表示される
     */
    maxLine: {
      type: Number,
      default: 0,
      validator: (value: number) => value >= 0,
    },

    /**
     * コメント本文の文字サイズ
     */
    fontSize: {
      type: String as PropType<'small' | 'normal' | 'large'>,
      default: 'normal',
    },
  },
})
</script>

<template>
  <div
    class="o-label__comment"
    :data-reply="isReply"
    :data-font="fontSize">
    <a
      v-if="href"
      class="o-label__comment--link"
      :href="href">
      <p class="o-label__comment--item is-primary">
        <span
          v-if="isReply"
          class="o-label__comment--icon">
          <ReplyIcon fill-color="#707070" />
        </span>
        <TextTruncationMultiLine
          :max-line="maxLine"
          class-name="o-label__comment--label">
          <slot />
        </TextTruncationMultiLine>
      </p>
      <p
        v-if="maxLine > 0"
        class="o-label__comment--item is-secondary">
        続きを読む
      </p>
    </a>

    <p
      v-else
      class="o-label__comment--item is-primary">
      <span
        v-if="isReply"
        class="o-label__comment--icon">
        <ReplyIcon fill-color="#707070" />
      </span>
      <TextTruncationMultiLine
        :max-line="maxLine"
        class-name="o-label__comment--label">
        <slot />
      </TextTruncationMultiLine>
    </p>
  <!-- /.o-label__comment --></div>
</template>

<style lang="sass" scoped>
.o-label__comment
  $root: &
  $reply-icon-width: 1.2em
  $reply-icon-margin: 0.2em

  & &--link
    display: block
    text-decoration: none

  & &--item
    color: $font-black

    &.is-secondary
      position: relative
      color: $font-dark-blue

      &::after
        content: ""
        width: 0.25em
        height: 0.25em
        display: inline-block
        transform: rotate(-45deg)
        line-height: 1.6
        vertical-align: middle
        margin-top: -0.2em
        border:
          bottom: 0.12em solid $border-dark-blue
          right: 0.12em solid $border-dark-blue

      +mouseover
        text-decoration: underline

  & &--icon
    width: $reply-icon-width
    display: block
    position: absolute
    top: 0.2em
    left: 0

  & &--label
    white-space: pre-wrap
    word-break: break-word

  &[data-reply="true"]
    #{$root}--item
      &.is-primary
        position: relative
        padding-left: $reply-icon-width + $reply-icon-margin

  &[data-font="small"]
    #{$root}--item
      font-size: $font-small

  &[data-font="normal"]
    #{$root}--item
      font-size: $font-normal

  &[data-font="large"]
    #{$root}--item
      font-size: $font-large
</style>
